import { alias, deserialize, serializable } from 'serializr';
import { Base } from './base.model';
import { User } from './user.model';
import { PageObject } from './page-object.model';

export class WdaProfile extends Base implements PageObject {
  @serializable
  public name: string;
  @serializable
  public fileName: string;
  @serializable
  public wdaPresignedUrl: string;
  @serializable
  public timesUsed: number;
  @serializable(alias('wdaFileSizeInBytes'))
  public wdaFileSize: number;
  @serializable
  public createdAtEpoch: string;
  public createdBy: User;
  public updatedBy: User;
  deserialize(input: any): this {
    return Object.assign(this, deserialize(WdaProfile, input));
  }
}
